import { Injectable } from '@angular/core';
import * as MicrosoftTeams from '@microsoft/teams-js';
import { Observable, of } from 'rxjs';
import { TeamsOperationStatus } from '@nimbus-global/features/shared/models/api/teams-operation-status.model';
import { Settings } from '@nimbus-global/features/shared/models/settings.model';
import { BaseTeamsService } from '@nimbus-library/features/shared/services/team/base/base-teams.service';

@Injectable()
export class TeamsService extends BaseTeamsService {
  public registerOnRemoveHanddler(): void {}
  public registerOnSaveHandler(): void {}
  public refreshSettings() {}

  public getSettings$(): Observable<Settings> {
    return of(null);
  }

  public setValidityOfSettings(valid: boolean) {}

  public publishOperationResult(status: TeamsOperationStatus) {}

  public getTabInstances(preload: boolean): Observable<MicrosoftTeams.TabInstance[]> {
    return of(null);
  }
}
